import 'react-datepicker/dist/react-datepicker.css';
import { Field, Form } from 'react-final-form';
import { Button, ButtonToolbar } from 'reactstrap';
import Icon from '../../../assets/icons/Icon';
import CustomDropZone from '../../../components/form/CustomDropZone';
import CustomInputField from '../../../components/form/CustomInputField';
import { useDict } from '../../../contexts/LanguageContext';

const DocumentsUpload = (props) => {
    const {
        onSubmit,
        isLoading,
        previousPage,
        fileChangedHandler,
        isPassport,
    } = props;

    const dict = useDict();

    const nationalICUploadGuide = (
        <>
            <div className="card__title">
                <h5 className="bold-text text-black margin-top-10">
                    {dict.nationalICUploadGuideTitle}</h5>
            </div>
            <h5>{dict.nationalICUploadGuideSubtitle}</h5>
            <ul className="text-black">
                <li>{dict.nationalICUploadGuideList1}</li>
                <li>{dict.nationalICUploadGuideList2}</li>
                <li>{dict.nationalICUploadGuideList3}</li>
                <li>{dict.nationalICUploadGuideList4}</li>
                <li>{dict.nationalICUploadGuideList5}</li>
            </ul>
        </>
    );

    const labelFront = isPassport
        ? dict.passportFront
        : dict.nationalICFront
    const labelBack = isPassport
        ? dict.passportBack
        : dict.nationalICBack
    const message = isPassport
        ? dict.passportMessage
        : (
            <>
                {dict.nationalICMessage}
                {nationalICUploadGuide}
            </>
        );

    const docsUploadValidate = (values) => {
        const errors = {};
        if (!isPassport) {
            if (!values.file_front) {
                errors.file_front = dict.fileFrontEmpty;
            } else if (values.file_front.length === 0) {
                errors.file_front = dict.fileFrontEmpty;
            } else if (
                values.file_front !== undefined &&
                values.file_front[0].size > 6291456
            ) {
                errors.file_front = dict.fileTooLarge;
            }
            if (!values.file_back) {
                errors.file_back = dict.fileBackEmpty;
            } else if (values.file_back.length === 0) {
                errors.file_front = dict.fileBackEmpty;
            } else if (
                values.file_back &&
                values.file_back[0].size > 6291456
            ) {
                errors.file_back = dict.fileTooLarge;
            }
        } else if (!values.file_front) {
            errors.file_front = dict.fileFrontEmpty;
        } else if (values.file_front.length === 0) {
            errors.file_front = dict.fileFrontEmpty;
        } else if (
            values.file_front !== undefined &&
            values.file_front[0].size > 6291456
        ) {
            errors.file_front = dict.fileTooLarge;
        }
        return errors;
    };

    return (
        <Form
            onSubmit={onSubmit}
            validate={docsUploadValidate}
        >
            {({ handleSubmit }) => (
                <form
                    className="form form--horizontal wizard__form_2"
                    onSubmit={handleSubmit}
                >
                    {isLoading && (
                        <div className="panel__refresh">
                            <Icon icon="Loading" />
                        </div>
                    )}
                    <Field name="identification_type_id">
                        {({ input, meta }) => (
                            <CustomInputField
                                input={input}
                                meta={meta}
                                type="text"
                                style={{
                                    display: 'none',
                                }}
                            />
                        )}
                    </Field>
                    <div
                        className="form__form-group bottom-border-dashed"
                    >
                        <div
                            className="card__title"
                            style={{ marginBottom: '5px' }}
                        >
                            <h5
                                className="bold-text"
                                style={{ fontSize: '14px' }}
                            >
                                {dict.requiredDocuments}
                            </h5>
                            <h5 className="subhead">
                                {dict.allowedDocumentsText}
                            </h5>
                            <h5
                                className="subhead"
                                style={{ fontWeight: 'bold' }}
                            >
                                {message}
                            </h5>
                        </div>
                    </div>
                    <div className="form__form-group" data-private>
                        <Field name="file_front" type="file">
                            {({ input, meta }) => (
                                <CustomDropZone
                                    input={input}
                                    meta={meta}
                                    label={labelFront}
                                    customHeight
                                    fileChangedHandler={(file) =>
                                        fileChangedHandler(file, 'front')
                                    }
                                    data-cy="documentsUpload__icFront"
                                />
                            )}
                        </Field>
                    </div>
                    {!isPassport && (
                        <div className="form__form-group" data-private>
                            <Field name="file_back">
                                {({ input, meta }) => (
                                    <CustomDropZone
                                        input={input}
                                        meta={meta}
                                        label={labelBack}
                                        customHeight
                                        fileChangedHandler={(file) =>
                                            fileChangedHandler(file, 'back')
                                        }
                                        data-cy="documentsUpload__icBack"
                                    />
                                )}
                            </Field>
                        </div>
                    )}
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <Button
                            color="primary"
                            type="button"
                            className="previous btn-outline-primary btn_uni rounded"
                            onClick={previousPage}
                            data-cy="documentsUpload__backBtn"
                        >
                            {dict.back}
                        </Button>
                        <Button
                            type="submit"
                            className={`next btn btn-primary btn_uni rounded ${isLoading && 'disabled'}`}
                            data-cy="documentsUpload__submitBtn"
                        >
                            {dict.next}
                        </Button>
                    </ButtonToolbar>
                </form>
            )}
        </Form>
    );
};

export default DocumentsUpload;
